import { render, staticRenderFns } from "./afterSaleDetail.vue?vue&type=template&id=1b6b47f4&scoped=true&"
import script from "./afterSaleDetail.vue?vue&type=script&lang=js&"
export * from "./afterSaleDetail.vue?vue&type=script&lang=js&"
import style0 from "./afterSaleDetail.vue?vue&type=style&index=0&id=1b6b47f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6b47f4",
  null
  
)

export default component.exports